import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/spatial`;

const spatialApi = axios.create({ baseURL: API_URL });

// Use the main FCA auth token for all Spatial requests
spatialApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses — redirect to main FCA login
spatialApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default spatialApi;
